import Typography from '@ixigo/iui/Typography';

interface OTPSectionProps {
	otp: {
		label: string;
		value: string;
	};
}

export function OTPSection({ otp }: OTPSectionProps) {
	const otpDigits = otp.value.split('');

	return (
		<div className="flex justify-between items-center bg-secondary p-10 w-full rounded-10">
			<Typography variant="body-xs" className="text-secondary">
				{otp.label}
			</Typography>
			<div className="flex gap-0.5 items-center justify-start relative font-medium text-info-solid">
				{otpDigits.map((digit, index) => (
					<Typography
						key={index}
						variant="body-xs"
						className="bg-info-solid px-1 rounded-sm w-15"
					>
						{digit}
					</Typography>
				))}
			</div>
		</div>
	);
}
